<template>
  <v-card color="gray10 pa-5">
    <div
      v-if="currentCoin"
      class="d-flex flex-column flex-sm-row align-sm-center justify-space-between"
    >
      <div
        class="text-white font-Regular-12 d-flex flex-column align-sm-center"
      >
        <span class="text-grey font-Bold-12 mb-2">{{
          $t("exchange.newPrice")
        }}</span>
        {{
          $thousandMask(currentCoin.close, currentCoin.frontBaseCoinScale, true)
        }}
      </div>

      <div class="d-flex flex-column align-sm-center">
        <span class="text-grey font-Bold-12 mb-2">{{
          $t("exchange.change")
        }}</span>
        <p
          class="mb-0 price-style"
          :class="
            currentCoin.chg >= 0
              ? currentCoin.chg === 0
                ? ''
                : 'green--text'
              : 'red--text'
          "
        >
          <span v-if="currentCoin.chg > 0">+</span>
          <span v-if="currentCoin.chg < 0">-</span>
          <span>{{ Math.abs((currentCoin.chg * 100).toFixed(2)) }}%</span>
        </p>
      </div>
      <div class="d-flex flex-column align-sm-center">
        <span class="text-grey font-Bold-12 mb-2">{{
          $t("exchange.high")
        }}</span>
        <div class="text-white font-Regular-12">
          {{ $thousandMask(currentCoin.high, currentCoin.frontBaseCoinScale) }}
        </div>
      </div>
      <div class="d-flex flex-column align-sm-center">
        <span class="text-grey font-Bold-12 mb-2">
          {{ $t("exchange.low") }}
        </span>
        <div class="text-white font-Regular-12">
          {{ $thousandMask(currentCoin.low, currentCoin.frontBaseCoinScale) }}
        </div>
      </div>
      <div class="d-flex align-center">
        <div
          class="d-flex flex-column align-sm-center ms-4"
          v-if="currentCoin.coinType !== 'VIRTUAL'"
        >
        <span class="text-grey font-Bold-12 mb-2">{{
            $t("exchange.exchangeNum")
          }}</span>
          <div class="text-white font-Regular-12">
            {{
              $thousandMask(
                currentCoin.twentyFourHourTurnover.toFixed(
                  currentCoin.frontBaseCoinScale
                )
              )
            }}
            {{ currentCoin.symbol.split("/")[1] }}
          </div>
        </div>
        <div v-else>
          <div
            @click="coinTypeDescriptionModal = true"
            class="coin-type-box primary--text demotrading-btn"
          >
            {{ $t("exchange.demoMarket") }}
          </div>
        </div>

        <button @click="loadCurvsScript" class="analyst-btn ms-4">
          <img src="@/assets/image/ai.svg" alt="ai-chat" />
          <span>{{ $t("shared.analyst") }}</span>
        </button>
      </div>

      <div class="d-flex align-center">
        <div class="d-flex align-center" @click="openMarketList = true">
          <v-icon class="mx-2" size="20">$downMarketListIcon</v-icon>
          <span class="font-Regular-20 cursor-pointer mt-1">
            {{ currentCoin.symbol }}
          </span>

          <img
            :src="`${imageBaseURL}/${currentCoin.coinSymbol}.svg`"
            :alt="currentCoin.baseSymbol"
            width="40"
            class="mx-2 cursor-pointer"
          />
        </div>

        <v-btn icon @click="toggleFavorite" v-if="isAuth">
          <v-icon
            :class="[
              'favorite-icon',
              {
                'svg-color-secondary': currentCoin.isFavor
              }
            ]"
            class="me-2"
            style="cursor: pointer"
            size="24"
          >
            $favoriteStar
          </v-icon>
        </v-btn>
      </div>

      <v-dialog v-model="coinTypeDescriptionModal" width="500">
        <v-card class="pa-4 gray10">
          <div class="modal-description" style="line-height: 1.8">
            {{ $t("exchange.modalText01") }}
          </div>
          <div class="mt-3 mb-3 modal-description" style="line-height: 1.8">
            {{ $t("exchange.modalText02") }}
          </div>
          <div class="modal-description" style="line-height: 1.8">
            {{ $t("exchange.modalText03") }}
          </div>
          <div class="text-left mt-5">
            <v-btn
              type="primary"
              @click="coinTypeDescriptionModal = false"
              color="primary"
            >
              {{ $t("common.getRealized") }}
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>{{ $t("common.nodata") }}</div>

    <v-navigation-drawer
      v-model="openMarketList"
      app
      temporary
      :right="!$vuetify.rtl"
      width="400"
      color="gray10"
      class="market-list-sidebar"
    >
      <marketsList />
    </v-navigation-drawer>
  </v-card>
</template>
<script>
import $thousandMask from "@/mixins/thousandMask";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { ExchangeService } from "@/services";
import { authMixin } from "@/mixins/authMixin";
import marketsList from "@/components/Market/exchange/MarketList.vue";

export default {
  name: "currentCard",
  components: { marketsList },
  mixins: [$thousandMask, authMixin],
  data() {
    return {
      coinTypeDescriptionModal: false,
      openMarketList: false,
      imageBaseURL: process.env.VUE_APP_IMAGE_BASE_URL
    };
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN
    })
  },

  methods: {
    ...mapActions({
      setCurrentCoin: types.marketExchange.actions.SET_CURRENT_COIN
    }),
    loadCurvsScript() {
      this.$emit("loadCurvsScript");
    },
    toggleFavorite() {
      let payload = {
        symbol: this.currentCoin.symbol
      };
      const api = !this.currentCoin.isFavor
        ? ExchangeService.addFavoredMarkets
        : ExchangeService.deleteFavoredMarkets;
      api(payload)
        .then(response => {
          if (response.data.code === 0) {
            this.$toast.success(
              !this.currentCoin.isFavor
                ? this.$t("exchange.do_favorite")
                : this.$t("exchange.cancel_favorite")
            );
            this.setCurrentCoin({
              ...this.currentCoin,
              isFavor: !this.currentCoin.isFavor
            });
          }
        })
        .catch(err => {
          this.$toast.error(err.message);
        });
    },
    getFavor() {
      ExchangeService.getFavoredMarkets().then(response => {
        const favFount = response.data.data.find(
          item => item.symbol === this.$route.params.pair.replace("_", "/")
        );
        if (favFount) {
          this.setCurrentCoin({
            ...this.currentCoin,
            isFavor: true
          });
        }
      });
    }
  }
};
</script>
<style lang="scss">
.demotrading-btn {
  border: 1px solid #815bff;
  border-radius: 6px;
  cursor: pointer;
  padding: 10px;
}
.analyst-btn {
  background-color: var(--v-primary-base);
  padding: 8px 12px;
  border-radius: 32px;
  color: white;
  display: flex;
  align-items: center;
  gap: 6px;
}
.market-list-sidebar {
  margin: 8px;
  height: calc(100vh - 16px) !important;
}
.svg-color-secondary {
  path:last-child {
    fill: var(--v-warning-base) !important;
    stroke: var(--v-warning-base) !important;
  }
}
</style>
